const EXAMPLE_DIR = "/assets/style-examples";

const STYLE_EXAMPLE_SRC_BY_ID: Record<string, string> = {
  "painterly-illustration": `${EXAMPLE_DIR}/painterly-example.webp`,
  "cinematic-realism": `${EXAMPLE_DIR}/cinematic-example.webp`,
  "bright-editorial-illustration": `${EXAMPLE_DIR}/bright-example.webp`,
  "storybook-illustration": `${EXAMPLE_DIR}/storybook-example.webp`,
  "concept-art-environment": `${EXAMPLE_DIR}/concept-art-example.webp`,
  "painterly-landscape": `${EXAMPLE_DIR}/painterly-landscape-example.webp`,
  "architectural-rendering": `${EXAMPLE_DIR}/architectural-example.webp`,
  "historical-scene": `${EXAMPLE_DIR}/historical-example.webp`,
  "item-study": `${EXAMPLE_DIR}/item-study-example.webp`,
  "emblem-insignia": `${EXAMPLE_DIR}/emblem-example.webp`,
  "cartographic-map": `${EXAMPLE_DIR}/cartographic-map-example.webp`,
  "creature-study": `${EXAMPLE_DIR}/creature-study-example.webp`,
  "mythic-illustration": `${EXAMPLE_DIR}/mythic-illustration-example.webp`,
  "interior-view": `${EXAMPLE_DIR}/interior-view-example.webp`,
};

export function getStyleExampleSrc(styleId: string): string | null {
  return STYLE_EXAMPLE_SRC_BY_ID[styleId] ?? null;
}
